import React from 'react';

import { ContentfulNavigationLinkExternal, ContentfulNavigationLinkInternal } from '../../contentful/types';

import { Image } from '../Image/Image';
import { PageComponent } from '../PageComponent/PageComponent';
import { RichText } from '../RichText/RichText';

import { createURLSlug } from '../../utils/createURLSlug';

import { Button } from '../Button/Button';

import { CarouselSlideProps } from './Carousel.types';

import * as classes from './CarouselSlide.module.scss';

const CarouselSlide: React.FC<CarouselSlideProps> = ({
    title,
    icons,
    singleColumnContent,
    backgroundImage,
    linkMore,
    isOnlyOneElement,
}) => {
    const checkURL = (link: ContentfulNavigationLinkInternal | ContentfulNavigationLinkExternal) => {
        let linkURL = '';
        let shouldOpenInNewTab = false;
        if (link) {
            if ('pageReference' in link && link.pageReference) {
                linkURL = `/${createURLSlug(link.pageReference, link.anchor)}`;
            } else if ('url' in link && link.url) {
                linkURL = link.url;
                shouldOpenInNewTab = true;
            }
        }
        return { shouldOpenInNewTab, linkURL };
    };

    const linkDatas = linkMore && checkURL(linkMore);

    const attr = linkDatas?.shouldOpenInNewTab
        ? { ...{ target: '_blank', rel: 'noopener noreferrer' } }
        : { ...{ target: '_self', rel: 'nofollow' } };

    return (
        <div
            style={{
                backgroundImage: backgroundImage ? `url(${backgroundImage.file.url})` : '',
            }}
            className={classes.carouselSlideContainer}
        >
            <PageComponent>
                <div
                    className={
                        isOnlyOneElement ? classes.carouselContentContainerOneEl : classes.carouselContentContainer
                    }
                >
                    <div className={classes.col}>
                        <div className={classes.icons}>
                            {icons?.map((el, i) => {
                                return (
                                    <Image
                                        key={i}
                                        image={el}
                                        classWrapper={classes.iconWrapper}
                                        classImg={classes.icon}
                                    />
                                );
                            })}
                        </div>
                        <RichText content={title} textSize="heading3" />
                    </div>
                    <div className={classes.col}>
                        <RichText content={singleColumnContent} textSize="text1SmallerSpacing" bulletType="CheckMark" />
                        {linkMore && (
                            <div className={classes.linkLearnMoreContainer}>
                                <a href={linkDatas?.linkURL} className={classes.linkLearnMore} {...attr}>
                                    <Button tag="span" variant="secondaryInverted">
                                        {linkMore.title}
                                    </Button>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </PageComponent>
        </div>
    );
};

export default CarouselSlide;
